var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.checkPermi(["admin:statistics:home:index"])
        ? _c("base-info", { ref: "baseInfo" })
        : _vm._e(),
      _c("grid-menu", { staticClass: "mb14" }),
      _c("user-overview"),
      _c("visit-chart", { ref: "visitChart" }),
      _vm.checkPermi(["admin:statistics:home:chart:user"])
        ? _c("user-chart", { ref: "userChart", staticClass: "mb20" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }